import React, { Fragment } from 'react'

import PropTypes from 'prop-types'

import './features1.css'

const Features1 = (props) => {
  return (
    <div
      className={`features1-thq-section-elm quick-links ${props.rootClassName} `}
    >
      <div className="features1-thq-heading-elm">
        <h3 className="features1-thq-header-elm">
          {props.header ?? (
            <Fragment>
              <span className="features1-text2">Virtual Assistant</span>
            </Fragment>
          )}
        </h3>
      </div>
      <p className="features1-text1">{props.description}</p>
      <div className="features1-thq-divider-elm"></div>
    </div>
  )
}

Features1.defaultProps = {
  rootClassName: '',
  description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
  header: undefined,
}

Features1.propTypes = {
  rootClassName: PropTypes.string,
  description: PropTypes.string,
  header: PropTypes.element,
}

export default Features1
